export default {
    path: '/',
    name: 'AiShare',
    component: resolve => require(['@/views/share/aiShare'], resolve),
    redirect: '/aiShare', 
    children: [
        {
            path: '/aiShare',
            name: 'aiShare',
            meta: [{
                path: '/aiShare',
                title: 'AI',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/share/aiShare.vue'], resolve),
        },
    ],
}